module.exports = __webpack_public_path__ + "static/headlinecasing-do-899b64f3a55997758406f9cd3e93177d.png";